import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect } from 'react'
import AsyncSelect from 'react-select/async'
import Select from 'react-select'
import axios from 'axios'
import _ from 'lodash'
import { fixDateString, getDay, getMonth } from '../../helpers/formatDate'
import ImageUploading from 'react-images-uploading'
import ImageModal from '../../components/image_modal/ImageModal'
import { replaceAccentedCharacters } from '../../helpers/utils'
import TaskDescription from './components/TaskDescription'
import TaskClientOrAttribute from './components/TaskClientOrAttribute'
import { useTaskAttributeQualifiers } from './components/TaskAttributeHelper'
import TaskScheduleConfig from './components/TaskScheduleConfig'
import {
  getTaskSchedulePayloadForCollect,
  isTaskFormSubmittable
} from './utils/posTaskSchedule'
import {
  getValidPackages,
  getPackageDisplayValue,
  getPackageColumns
} from './components/packageHelper'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import GoogleIcon from '../../icon/GoogleIcon'
import { TextField, MenuItem, Box, Typography } from '@mui/material'

let countsCache = {
  brand: {},
  category: {}
}

const PlanimetryVerificationTask = ({
  setCloningTask,
  cloningTask,
  setFailedCreation,
  failedCreation,
  taskData,
  readyToCollect,
  setReadyToCollect,
  setSaving,
  formDataCollector,
  isStep3Completed,
  setIsStep3Completed
}) => {
  const [description, setDescription] = useState('')
  const [instruction, setInstruction] = useState('')
  const [clientOrAttribute, setClientOrAttribute] = useState('')
  const [clients, setClients] = useState([])
  const [products, setProducts] = useState([])
  const [brand, setBrand] = useState('')
  const [category, setCategory] = useState('')
  const [productSelection, setProductSelection] = useState('')
  const {
    qualifiers,
    setQualifiers,
    selectedQualifiers,
    qualifierOptions,
    handleChangeQualifier,
    resetSelectedQualifiers,
    isSomeQualifierSelected,
    validateAtLeastOneQualifier,
    getCollectDataQualifierFields,
    applyClonedTaskQualifiers
  } = useTaskAttributeQualifiers()
  const [users, setUsers] = useState([])
  const [userOptions, setUserOptions] = useState(null)
  const [userFilterChecked, setUserFilterChecked] = useState(false)
  const [isMandatoryTask, setIsMandatoryTask] = useState(false)
  const [newStartTime, setNewStartTime] = useState(null)
  const [newEndTime, setNewEndTime] = useState(null)
  const [schedulePayload, setSchedulePayload] = useState(null)
  const [showMandatoryConflict, setShowMandatoryConflict] = useState(false)
  const [productsBase, setProductsBase] = useState({})
  const [productCount, setProductCount] = useState('...')

  const [images, setImages] = useState([])
  const [showImage, setShowImage] = useState(false)
  const maxNumber = 1
  const maxMbFileSize = 5242880
  const newLinePoint = '\u2022'
  const pointWithSpace = `${newLinePoint} `
  const packageColumns = getPackageColumns(products)

  const productSelectionType = [
    { value: '', text: 'Escoja una opción', hidden: true },
    { value: 'brand', text: 'Marca' },
    { value: 'category', text: 'Categoría' },
    { value: 'individual_products', text: 'Producto individual' }
  ]

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  var abortClientController = new AbortController()
  var abortProductController = new AbortController()
  const abortCurrentFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
    abortProductController.abort('Fetch Aborted by User.')
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  // Stops client fetch when is unfocus
  const abortClientFetchs = () => {
    abortClientController.abort('Fetch Aborted by User.')
  }
  //

  // Stops products fetch when is unfocus
  const abortProductFetchs = () => {
    abortProductController.abort('Fetch Aborted by User.')
  }
  //

  const openUrlNewWindow = (url) => {
    window.open(url, '_blank')
  }

  const handleStartTimeChange = (newStartTime) => {
    setNewStartTime(newStartTime)
  }

  const handleEndTimeChange = (newEndTime) => {
    setNewEndTime(newEndTime)
  }

  const handleMandatoryConflict = () => {
    setIsMandatoryTask(false)
    setShowMandatoryConflict(true)
  }

  const handleDismissMandatoryConflict = () => {
    setShowMandatoryConflict(false)
  }

  const handleProductSelectionChange = (event) => {
    setProductSelection(event.target.value)
    setProducts([])
    setBrand(null)
    setCategory(null)
    setInstruction('')
    setImages([])
  }

  const handleInstructionChange = (event) => {
    let value = event.target.value

    if (value.trim() === '') {
      setInstruction('')
      return
    }

    if (!value.startsWith(pointWithSpace)) {
      value = pointWithSpace + value.replace(/^•?\s*/, '')
    }

    let splitByBullets = value.split(`\n${pointWithSpace}`)
    let cleaned = splitByBullets
      .filter((e, i) => e !== '' || i === splitByBullets.length - 1)
      .join(`\n${pointWithSpace}`)

    setInstruction(cleaned)
  }

  const handleInstructionKeyDown = (event) => {
    if (event.key !== 'Enter') return

    event.preventDefault()

    const cursorPosition = event.target.selectionStart
    const textBefore = instruction.substring(0, cursorPosition)
    const textAfter = instruction.substring(cursorPosition)

    const newText = textBefore + '\n' + pointWithSpace + textAfter

    setInstruction(newText)

    setTimeout(() => {
      event.target.selectionStart =
        event.target.selectionEnd =
        cursorPosition + pointWithSpace.length + 1
    }, 0)
  }

  const isAnyKindOfProductSelected = () => {
    if (products?.length > 0 || brand || category) {
      return true
    }
    return false
  }

  const isClientOrSomeQualifierSelected = () => {
    if (clients?.length > 0 || isSomeQualifierSelected()) {
      return true
    }
    return false
  }

  const handleClientOrAttributeChange = (event) => {
    setClientOrAttribute(event.target.value)
    setClients([])
    resetSelectedQualifiers()
    setUserFilterChecked(false)
    setUsers([])
  }

  const handleBrandsChange = (event) => {
    if (event?.brand) {
      setBrand(event.brand)
    }
  }

  const handleCategoryChange = (event) => {
    if (event?.category) {
      setCategory(event.category)
    }
  }

  const getClient = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortClientController = new AbortController()
      return authFetch(
        `${BASE_BACKEND_URL}/clients?q=${inputValue}&active=true`,
        {
          method: 'GET',
          signal: abortClientController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
        if (!response) return
        return response.json()
      })
        .then((data) =>
          data.table.map((cl) => ({
            value: cl.name,
            label: `${cl.name} - ${cl.db_ref}`,
            client: cl
          }))
        )
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error fetching clients:', error)
            return []
          }
        })
    }
  }

  const getQualifiers = () => {
    const url = `${BASE_BACKEND_URL}/promo_qualifiers`

    authFetch(url, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setQualifiers(data.result[0])
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const displayProductCount = (product_count) => {
    if (product_count == '...') {
      return 'Cargando...'
    }
    let brandCountNum = Number(product_count)
    return isNaN(brandCountNum)
      ? '...'
      : `${brandCountNum} - ${brandCountNum > 1 || brandCountNum == 0 ? 'PRODUCTOS ACTIVOS' : 'PRODUCTO ACTIVO'
      }`
  }

  const getUsers = () => {
    authFetch(
      `${BASE_BACKEND_URL}/ubiqua_app_users?non_paginated=true`,
      {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setUserOptions(
          data.table.map((u) => ({
            value: u.full_name,
            label: `${u.full_name} - ${u.uid}`,
            user: u
          }))
        )
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getUserForCloning = async (uid) => {
    return authFetch(
      `${BASE_BACKEND_URL}/ubiqua_app_users/${uid}?active=true`,
      {
        method: 'GET',
        signal: abortController.signal,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      }
    )
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        return {
          value: data.full_name,
          label: `${data.full_name} - ${data.uid}`,
          user: data
        }
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getProductsCount = async () => {
    let type = ''
    let typeData = null
    if (category) {
      type = 'category'
      typeData = category.db_ref
    }
    if (brand) {
      type = 'brand'
      typeData = brand.db_ref
    }
    if (typeData) {
      if (countsCache[type][typeData]) {
        setProductCount(countsCache[type][typeData])
      } else {
        setProductCount('...')
        try {
          let resp = await authFetch(
            `${BASE_BACKEND_URL}/products?by_${type}=${typeData}&count_only=true`,
            {
              method: 'GET',
              signal: abortController.signal,
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              }
            }
          )
          if (resp.status != 200) {
            console.error('Error al obtener el conteo de productos')
            setProductCount(0)
          }

          let data = await resp.json()
          countsCache[type][typeData] = data.result
          setProductCount(data.result)
        } catch (error) {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        }
      }
    } else {
      setProductCount('...')
    }
  }

  const clearProductBrandOrCategory = () => {
    setBrand(null)
    setCategory(null)
  }

  const getProductsBaseData = () => {
    authFetch(`${BASE_BACKEND_URL}/products/promo_necessary_data`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setProductsBase(data)
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const getProducts = async (inputValue) => {
    if (inputValue.length >= 3) {
      abortProductController = new AbortController()
      return authFetch(
        `${BASE_BACKEND_URL}/products?q=${replaceAccentedCharacters(
          inputValue
        )}&productactive=true`,
        {
          method: 'GET',
          signal: abortProductController.signal,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then((data) => {
          const lookup = _.keyBy(products, (p) => p.db_ref)
          return data.table
            .filter((d) => !lookup[d.db_ref])
            .map((p) => ({
              value: p.name,
              label: `${p.name} - ${p.db_ref}`,
              product: p
            }))
        })
        .catch((error) => {
          if (error !== 'Fetch Aborted by User.') {
            console.error('Error:', error)
          }
        })
    }
  }
  const handleClientOption = (options) => {
    setClients(options)
  }

  const handleUsersChange = (options) => {
    setUsers(options)
  }

  const handleProductOption = (options) => {
    if (!options?.product) {
      return
    }
    let alreadyExist = products.find((e) => e.id === options.product.id)
    if (alreadyExist) {
      return
    }
    setProducts([...products, options.product])
  }

  const handleImageChange = (imageList, addUpdateIndex) => {
    // data for submit
    setImages(imageList)
  }

  const convertByteToMb = (imgBytes) => {
    let mb = 0
    if (imgBytes) {
      mb = Number(imgBytes) / 1024 / 1024
    }
    return mb.toFixed(1) + 'MB'
  }

  const handleShowImage = (event) => {
    setShowImage(true)
  }

  const sleep = (ms) =>
    // eslint-disable-next-line no-undef
    new Promise((resolve) => {
      setTimeout(() => {
        resolve()
      }, ms)
    })

  const collectData = () => {
    const scheduleResult = getTaskSchedulePayloadForCollect({
      startDate: newStartTime,
      schedulePayload
    })
    if (!scheduleResult.ok) {
      setFailedCreation(scheduleResult.message)
      setReadyToCollect(false)
      setTimeout(() => setFailedCreation(false), 15000)
      return
    }

    const recurrencePayload = scheduleResult.payload

    let jsonData = {
      description: description,
      completion_mode: recurrencePayload.completion_mode,
      recurrence_format: recurrencePayload.recurrence_format,
      recurrence_interval: recurrencePayload.recurrence_interval,
      recurrence_description: recurrencePayload.recurrence_description,
      start_date: fixDateString(newStartTime),
      end_date: fixDateString(newEndTime),
      qualifier_1: clients.map((c) => c.client.db_ref).sort(),
      ...getCollectDataQualifierFields(),
      user_uids: userFilterChecked ? users.map((u) => u.user.uid).sort() : [],
      user_names: userFilterChecked ? users.map((u) => u.label).sort() : [],
      is_mandatory_task: isMandatoryTask,
      products_selection_type: productSelection,
      category_db_ref: category?.db_ref,
      category_name: category?.description,
      brand_db_ref: brand?.db_ref,
      brand_name: brand?.name,
      products_db_ref: products.map((p) => p.db_ref).sort(),
      product_names: products.map((p) => p.db_ref + ' ' + p.name).sort(),
      task_quantity: 1,
      instructions: instruction,
      image_data: images[0]?.data_url || null,
      image_url: images[0]?.image_url || null,
      image_reference: images[0]?.image_reference || null
    }

    formDataCollector(jsonData)
  }

  const setUpTask = async () => {
    if (taskData) {
      try {
        setCloningTask(true)
        setDescription(taskData.description)

        if (taskData.client_names?.length > 0) {
          setClientOrAttribute('client')
          let _clients = []
          for (const clientName of taskData.qualifier_1) {
            let c = await getClient(clientName)
            if (c?.length > 0) {
              _clients.push(c[0])
            }
          }
          setClients(_clients)
        } else {
          setClientOrAttribute('qualifier')
          applyClonedTaskQualifiers(taskData)
        }

        if (taskData.is_mandatory_task) {
          setIsMandatoryTask(true)
        }

        if (taskData.user_uids?.length > 0) {
          let _users = []
          for (const uid of taskData.user_uids) {
            let user = await getUserForCloning(uid)
            if (user) {
              _users.push(user)
            }
          }
          setUsers(_users)
          setUserFilterChecked(true)
        }
      } catch (e) {
        console.log('Error en duplicacion de tarea  (Clientes/Atributos/Usuarios): ', e)
        setFailedCreation(
          'Hubo un error al intentar obtener: Los clientes o atributos o usuarios, requeridos para crear la copia de la tarea. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        return setCloningTask(false)
      }
      try {
        switch (taskData.products_selection_type) {
          case 'individual_products':
            {
              setProductSelection('individual_products')
              let _products = []
              for (const productDbRef of taskData.products_db_ref) {
                let p = await getProducts(productDbRef)
                if (p?.length > 0) {
                  _products.push(p[0]?.product)
                }
              }
              let cleanProducts = _products.filter(
                (value, index, self) => index === self.findIndex((t) => t.db_ref === value.db_ref)
              )
              setProducts(cleanProducts)
            }
            break
          case 'brand':
            {
              setProductSelection('brand')
              let _brand = productsBase?.brand?.find((b) => b.db_ref === taskData.brand_db_ref)
              setBrand(_brand)
            }
            break
          case 'category':
            {
              setProductSelection('category')
              let _category = productsBase?.categories?.find(
                (c) => c.db_ref === taskData.category_db_ref
              )
              setCategory(_category)
            }
            break
        }
      } catch (e) {
        console.log('Error en duplicacion de tarea  (Productos/Marcas/Categorias): ', e)
        setFailedCreation(
          'Hubo un error al intentar obtener: Productos/Marcas/Categorias, requeridos para crear la copia de la tarea. Por favor, asegúrese de completar todos los campos faltantes en adelante.'
        )
        setTimeout(() => setFailedCreation(false), 15000)
        return setCloningTask(false)
      }

      if (taskData.image_url != null) {
        setImages([{ image_url: taskData.image_url, image_reference: taskData.image_reference }])
      }

      if (taskData.instructions != null) {
        setInstruction(taskData.instructions)
      }

      setCloningTask(false)
      await sleep(1000)
      setSaving(false)
    }
  }

  useEffect(() => {
    setIsStep3Completed(
      isTaskFormSubmittable({
        startDate: newStartTime,
        schedulePayload,
        isBaseComplete: clients.length > 0 || isSomeQualifierSelected()
      })
    )
  }, [clients, selectedQualifiers, isSomeQualifierSelected, newStartTime, schedulePayload])

  useEffect(() => {
    getQualifiers()
    getUsers()
    getProductsBaseData()
  }, [])

  useEffect(() => {
    if (taskData) {
      setUpTask()
    }
  }, [taskData, productsBase.brand, productsBase.categories])

  useEffect(() => {
    getProductsCount()
  }, [category, brand])

  useEffect(() => {
    if (readyToCollect) {
      collectData()
    }
  }, [readyToCollect])

  const isStep5Enabled = products.length > 0 || brand || category

  if (cloningTask) {
    return null
  }
  return (
    <>
      <TaskDescription initialDescription={description} onDescriptionChange={setDescription} />

      <div>
        <TaskClientOrAttribute
          clientOrAttribute={clientOrAttribute}
          handleClientOrAttributeChange={handleClientOrAttributeChange}
          clients={clients}
          handleClientOption={handleClientOption}
          abortClientFetchs={abortClientFetchs}
          getClient={getClient}
          selectedQualifiers={selectedQualifiers}
          qualifierOptions={qualifierOptions}
          onQualifierChange={handleChangeQualifier}
          validateAtLeastOneQualifier={() => validateAtLeastOneQualifier(selectedQualifiers)}
          description={description}
          isClientOrSomeQualifierSelected={isClientOrSomeQualifierSelected}
          isMandatoryTask={isMandatoryTask}
          setIsMandatoryTask={setIsMandatoryTask}
          recurrenceType={schedulePayload?.completion_mode}
          onMandatoryBlocked={handleMandatoryConflict}
          showMandatoryConflict={showMandatoryConflict}
          onDismissMandatoryConflict={handleDismissMandatoryConflict}
          userFilterChecked={userFilterChecked}
          setUserFilterChecked={setUserFilterChecked}
          users={users}
          userOptions={userOptions}
          handleUsersChange={handleUsersChange}
        />

        <div className="task-form-section">
          <div className="title-promos-form">
            <b class="bold-step">PASO 4: Escoja los productos que aplican a esta tarea</b>
          </div>
          <hr className="hr-task-form" />
          <p>Por marca, categoría o productos individuales</p>
          <div className="task-form-control-width ">
            <TextField
              select
              fullWidth
              size="small"
              label="Tipo de selección"
              value={productSelection}
              onChange={(e) => {
                if (!isClientOrSomeQualifierSelected()) return
                handleProductSelectionChange(e)
              }}
              required
              sx={{
                pointerEvents: !isClientOrSomeQualifierSelected() ? 'none' : 'auto',
                opacity: !isClientOrSomeQualifierSelected() ? 0.6 : 1,
                backgroundColor: !isClientOrSomeQualifierSelected() ? '#f0f0f0' : 'transparent',
                '& .MuiInputBase-input': {
                  cursor: !isClientOrSomeQualifierSelected() ? 'not-allowed' : 'pointer'
                }
              }}
            >
              {productSelectionType?.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{ display: option.hidden ? 'none' : 'block' }}
                >
                  {option.text}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div>
        {productSelection === 'individual_products' && (
          <div className="task-form-section">
            <div className="title-promos-form">
              <p>
                <b>PASO 4.1: Escoja los productos que aplican a esta tarea</b>
              </p>
            </div>
            <div className="task-form-control-width">
              <div className="fake-validator-container">
                <input
                  className="input-fake-validator"
                  type="text"
                  required
                  value={products.length >= 1 ? products : null}
                />
                <AsyncSelect
                  className="clients"
                  placeholder={'Escribir nombre o código del producto'}
                  noOptionsMessage={() => 'No hay resultados'}
                  loadingMessage={() => 'Cargando productos...'}
                  name="selectOptionProducts"
                  loadOptions={getProducts}
                  isClearable={true}
                  searchParamName={'q'}
                  isSearchable={true}
                  value={[]}
                  onChange={(e, am) => {
                    handleProductOption(e)
                    am.action = 'clear'
                  }}
                  onBlur={abortProductFetchs}
                />
              </div>
            </div>
            {products?.length > 0 && (
              <div className="row">
                <table className="table-pdv table-hover task-product-table">
                  <thead className="table-header-gray-task">
                    <tr>
                      <th className="pl-20">CÓDIGO</th>
                      <th>NOMBRE DEL PRODUCTO</th>
                      {packageColumns.map((column) => (
                        <th key={column.label}>{column.label}</th>
                      ))}
                      <th className="centered">ACCIÓN</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products?.map((product, index) => (
                      <tr key={`${product.id}-${index}`}>
                        <td className="pl-20">{product.db_ref}</td>
                        <td>{product.name}</td>
                        {packageColumns.map((column) => {
                          const productPackages = getValidPackages(product)

                          return <td key={`${product.id}-${column.label}`}>{getPackageDisplayValue(productPackages[column.index])}</td>
                        })}
                        <td
                          className="delete-selected-product"
                          onClick={(e) => setProducts(products.filter((p) => p.id !== product.id))}
                        >
                          &times;
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {productSelection === 'brand' && (
          <div className="task-form-section">
            <div className="title-promos-form">
              <p>
                <b>PASO 4.1: Seleccione la marca de los productos para esta tarea</b>
              </p>
            </div>
            <div className="task-form-control-width">
              <div className="fake-validator-container">
                <input
                  className="input-fake-validator"
                  type="text"
                  required
                  value={brand?.db_ref ? brand?.db_ref : null}
                />
                <Select
                  isDisabled={brand ? true : false}
                  placeholder={'Escoja una opcion'}
                  noOptionsMessage={() => 'No hay resultados'}
                  loadingMessage={() => 'Cargando...'}
                  className="qualifier"
                  isClearable={false}
                  value={brand ? { value: brand.db_ref, label: brand.name } : null}
                  onChange={(e) => handleBrandsChange(e)}
                  options={productsBase?.brand?.map((option) => {
                    return { value: option.db_ref, label: option.name, brand: option }
                  })}
                />
              </div>
            </div>
            {isAnyKindOfProductSelected() && (
              <div className="box-products-preview-container-pos mt-24">
                <div className="box-products-preview-pos mr-10">
                  <p className="m-0" title={brand?.name}>
                    {displayProductCount(productCount)}
                  </p>
                  <div onClick={clearProductBrandOrCategory} className="delete-selected-product">
                    &times;
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() =>
                    openUrlNewWindow(`/productos?by_brand=${brand.db_ref}&brand_name=${brand.name}`)
                  }
                  className="big-btn-tasks"
                >
                  Ver lista de productos
                </button>
              </div>
            )}
            <div className="task-form-section" />
          </div>
        )}
        {productSelection === 'category' && (
          <div className="task-form-section">
            <div className="title-promos-form">
              <p>
                <b>PASO 4.1: Seleccione la categoría de los productos para esta tarea</b>
              </p>
            </div>
            <div className="task-form-control-width">
              <div className="fake-validator-container">
                <input
                  className="input-fake-validator"
                  type="text"
                  required
                  value={category?.db_ref ? category?.db_ref : null}
                />
                <Select
                  isDisabled={category ? true : false}
                  placeholder={'Escoja una opcion'}
                  noOptionsMessage={() => 'No hay resultados'}
                  loadingMessage={() => 'Cargando...'}
                  className="qualifier"
                  isClearable={true}
                  value={category ? { value: category.db_ref, label: category.description } : null}
                  onChange={(e) => handleCategoryChange(e)}
                  options={productsBase?.categories?.map((option) => {
                    return { value: option.db_ref, label: option.description, category: option }
                  })}
                />
              </div>
            </div>
            {isAnyKindOfProductSelected() && (
              <div className="box-products-preview-container-pos mt-24">
                <div className="box-products-preview-pos mr-10">
                  <p className="m-0" title={category?.description}>
                    {displayProductCount(productCount)}
                  </p>
                  <div onClick={clearProductBrandOrCategory} className="delete-selected-product">
                    &times;
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() =>
                    openUrlNewWindow(
                      `/productos?by_category=${category.db_ref}&category_name=${category.description}`
                    )
                  }
                  className="big-btn-tasks"
                >
                  Ver listado de productos
                </button>
              </div>
            )}
            <div className="task-form-section" />
          </div>
        )}
        <div className="task-form-section">
          <div className="title-promos-form">
            <b class="bold-step">
              <span style={{ fontStyle: 'italic' }}>Opcional</span> - Adjunte una imagen de
              referencia
            </b>
          </div>
          <hr className="hr-task-form" />
          <div className="task-form-control-width">
            <ImageUploading
              multiple
              value={images}
              onChange={handleImageChange}
              maxNumber={maxNumber}
              maxFileSize={maxMbFileSize}
              resolutionType={'less'}
              acceptType={['jpg', 'png']}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps,
                errors
              }) => (
                <div className="upload__image-wrapper">
                  {imageList.length < 1 && (
                    <div className="form-group">
                      <div className="">
                        <div
                          className="planimetry-upload-drop-zone"
                          id="drop-zone"
                          style={isDragging ? { background: '#F0F4F7' } : undefined}
                          {...dragProps}
                        >
                          <div className="drag-drop-task-icon">
                            <GoogleIcon
                              name="cloud_upload"
                              size={55}
                              color="#597FA9"
                              weight={400}
                            />
                          </div>
                          <div className="planimetry-drop-text">
                            <b>Seleccione una sola imagen o arrástrela y suéltela aquí</b>
                          </div>
                          <div className="planimetry-drop-subtext">
                            JPG o PNG, tamaño del archivo no mayor a 5MB
                          </div>
                          <div className="planimetry-drop-subtext">ó</div>
                          <button
                            onClick={onImageUpload}
                            className="select-photo-button"
                            type="button"
                          >
                            Seleccionar imagen
                          </button>
                        </div>
                      </div>
                      {errors && (
                        <div className="img-error-message">
                          {errors.maxNumber && <span>Máximo de 1 imagen por tarea</span>}
                          {errors.maxFileSize && (
                            <span>
                              Asegúrate de que la imagen sea en formato .png o .jpg y tenga un
                              tamaño no mayor a 5MB.
                            </span>
                          )}
                          {errors.acceptType && (
                            <span>
                              Asegúrate de que la imagen sea en formato .png o .jpg y tenga un
                              tamaño no mayor a 5MB.
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {imageList?.map((image, index) => (
                    <div className="task-form-section">
                      <div
                        className="title-promos-form"
                        style={{ marginTop: -30, fontSize: 13, marginBottom: 10 }}
                      >
                        <b>Imagen agregada</b>
                      </div>
                      {image['data_url'] != undefined && (
                        <div className="img-load-wrapper-task">
                          <div className="img-load-div">
                            <div className="img-load-icon-task">
                              <GoogleIcon
                                name="cloud_upload"
                                size={24}
                                color="#597FA9"
                                weight={400}
                              />
                            </div>
                            <span className="img-load-text-task">{image['file'].name}</span>
                            <span className="img-load-text-task" style={{ marginLeft: 10 }}>
                              {convertByteToMb(image['file'].size)}
                            </span>
                            <button
                              type="button"
                              className="img-view-buttom-task"
                              onClick={(e) => {
                                handleShowImage(e)
                              }}
                            >
                              {' '}
                              Ver imagen
                            </button>

                          </div>
                          <button
                            type="button"
                            className="delete-image-button"
                            onClick={() => onImageRemove(index)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ margin: '0 !important' }}
                            >
                              <circle cx="12" cy="12" r="12" fill="#202020" />
                              <path
                                d="M12.6266 12L15.8666 8.75995C15.9395 8.67493 15.9775 8.56556 15.9732 8.45371C15.9689 8.34185 15.9225 8.23575 15.8433 8.15659C15.7642 8.07744 15.6581 8.03107 15.5462 8.02675C15.4344 8.02243 15.325 8.06048 15.24 8.13329L12 11.3733L8.75997 8.12884C8.67495 8.05603 8.56558 8.01798 8.45373 8.0223C8.34187 8.02662 8.23577 8.07299 8.15661 8.15215C8.07746 8.2313 8.03109 8.33741 8.02677 8.44926C8.02245 8.56112 8.0605 8.67049 8.13331 8.75551L11.3733 12L8.12886 15.24C8.08234 15.2798 8.04455 15.3288 8.01787 15.384C7.9912 15.4391 7.97621 15.4992 7.97384 15.5604C7.97148 15.6216 7.98179 15.6826 8.00414 15.7397C8.02648 15.7967 8.06037 15.8485 8.10369 15.8918C8.147 15.9351 8.1988 15.969 8.25583 15.9913C8.31286 16.0137 8.3739 16.024 8.43511 16.0216C8.49632 16.0193 8.55638 16.0043 8.61152 15.9776C8.66666 15.9509 8.71569 15.9131 8.75553 15.8666L12 12.6266L15.24 15.8666C15.325 15.9394 15.4344 15.9775 15.5462 15.9732C15.6581 15.9688 15.7642 15.9225 15.8433 15.8433C15.9225 15.7642 15.9689 15.6581 15.9732 15.5462C15.9775 15.4343 15.9395 15.325 15.8666 15.24L12.6266 12Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </div>
                      )}
                      {image['image_url'] != undefined && (
                        <div className="img-load-wrapper">
                          <div className="img-load-div">
                            <div className="img-load-icon">
                              <GoogleIcon
                                name="cloud_upload"
                                size={22}
                                color="#597FA9"
                                weight={400}
                              />                            </div>
                            <span className="img-load-text">{image['image_reference']}</span>
                            <button
                              type="button"
                              className="img-view-buttom"
                              onClick={(e) => {
                                handleShowImage(e)
                              }}
                            >
                              {' '}
                              Ver imagen
                            </button>
                          </div>
                          <span className="img-load-text" style={{ marginRight: 40 }}></span>
                          <button
                            type="button"
                            className="delete-image-button"
                            onClick={() => onImageRemove(index)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ margin: '0 !important' }}
                            >
                              <circle cx="12" cy="12" r="12" fill="#202020" />
                              <path
                                d="M12.6266 12L15.8666 8.75995C15.9395 8.67493 15.9775 8.56556 15.9732 8.45371C15.9689 8.34185 15.9225 8.23575 15.8433 8.15659C15.7642 8.07744 15.6581 8.03107 15.5462 8.02675C15.4344 8.02243 15.325 8.06048 15.24 8.13329L12 11.3733L8.75997 8.12884C8.67495 8.05603 8.56558 8.01798 8.45373 8.0223C8.34187 8.02662 8.23577 8.07299 8.15661 8.15215C8.07746 8.2313 8.03109 8.33741 8.02677 8.44926C8.02245 8.56112 8.0605 8.67049 8.13331 8.75551L11.3733 12L8.12886 15.24C8.08234 15.2798 8.04455 15.3288 8.01787 15.384C7.9912 15.4391 7.97621 15.4992 7.97384 15.5604C7.97148 15.6216 7.98179 15.6826 8.00414 15.7397C8.02648 15.7967 8.06037 15.8485 8.10369 15.8918C8.147 15.9351 8.1988 15.969 8.25583 15.9913C8.31286 16.0137 8.3739 16.024 8.43511 16.0216C8.49632 16.0193 8.55638 16.0043 8.61152 15.9776C8.66666 15.9509 8.71569 15.9131 8.75553 15.8666L12 12.6266L15.24 15.8666C15.325 15.9394 15.4344 15.9775 15.5462 15.9732C15.6581 15.9688 15.7642 15.9225 15.8433 15.8433C15.9225 15.7642 15.9689 15.6581 15.9732 15.5462C15.9775 15.4343 15.9395 15.325 15.8666 15.24L12.6266 12Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </ImageUploading>
          </div>
        </div>
        <div className="task-form-section">
          <div className="title-promos-form">
            <p>
              <b class="bold-step">
                <span style={{ fontStyle: 'italic' }}>Opcional</span> -  Agregue
                información o instrucciones necesarias para completar esta tarea
              </b>
            </p>
          </div>
          <div className="form-group task-form-control-width">
            <TextareaAutosize
              minRows={3}
              maxRows={12}
              maxLength={1000}
              className="form-control"
              id="instructions"
              name="instructions"
              value={instruction}
              placeholder="Escriba aquí..."
              onChange={handleInstructionChange}
              onKeyDown={handleInstructionKeyDown}
              style={{
                width: '100%',
                resize: 'none',
                overflow: 'hidden'
              }}
            />
            <p className="small text-muted mt-10 pull-right">
              Cantidad máxima de caracteres {Math.abs(instruction.length - 1000)}/1000
            </p>
          </div>
        </div>
      </div>
      <div className="task-form-section">
        <TaskScheduleConfig
          isEnabled={isStep5Enabled}
          onScheduleChange={setSchedulePayload}
          onStartChange={handleStartTimeChange}
          onEndChange={handleEndTimeChange}
          isMandatoryTask={isMandatoryTask}
          onMandatoryConflict={handleMandatoryConflict}
          showMandatoryConflict={showMandatoryConflict}
          onDismissMandatoryConflict={handleDismissMandatoryConflict}
        />
      </div>
      {images?.map(
        (image, index) =>
          (image['data_url'] || image['image_url']) && (
            <div key={index}>
              <ImageModal
                imgSrc={image['data_url'] || image['image_url']}
                showImage={showImage}
                setShowImage={setShowImage}
              />
            </div>
          )
      )}
    </>
  )
}
export default PlanimetryVerificationTask
